import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { TagiDto } from '../modele/tagi';
import { environment } from 'src/environments/environment';
import { PartnerDto } from 'src/app/core/modele/partnerDto';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class PartnerzyService {

  private basePHAPIUrl = environment.basePHAPIUrl;

  // Cache
  private partnerzyCache$?: Observable<PartnerDto[]>;

  constructor(private http: HttpClient) { }

  getPartnerzy(): Observable<PartnerDto[]> {
    if (!this.partnerzyCache$) {
      this.partnerzyCache$ = this.http
        .get<PartnerDto[]>(`${this.basePHAPIUrl}/partnerzy/findAll`)
        .pipe(shareReplay(1));
    }
    return this.partnerzyCache$;
  }

  getPartnerById(id: number): Observable<PartnerDto | undefined> {
    return this.getPartnerzy().pipe(
      map((partnerzy) => partnerzy.find(p => p.id === id))
    );
  }

  getPartnerByNazwaSkrot(nazwaSkrot: string): Observable<PartnerDto | undefined> {
    return this.getPartnerzy().pipe(
      map((partnerzy) => partnerzy.find(p => p.nazwaSkrot.toUpperCase() === nazwaSkrot.toUpperCase().trim()))
    );
  }
}
